module.exports = __webpack_public_path__ + "img/N774-2.7b0cad86.png";